/* BPO */
import * as financeStore from './store'

export function financeModule({ store }) {
  store.registerModule('finance', { ...financeStore, namespaced: true })
}

export const PERMISSION = 'bpo-finance'
